

























import Vue from 'vue'
import Component from 'vue-class-component'
import {Action, Getter, Mutation, State} from 'vuex-class';
import Permission from '@/modules/authorization/model/Permission';
import PermissionDetail from '@/modules/authorization/components/PermissionDetail.vue';
import AuthorizationItemTree from '@/modules/authorization/components/AuthorizationItemTree.vue';
import Loader from '@/components/Loader.vue';
import {CheckAuthorizationResult} from '@/modules/authorization/model/CheckAuthorizationResult';
import {Colors, notify} from '@/modules/core/notification';

/**
 * Pantalla maestra que muestra el árbol con los permisos de usuario
 *
 * @author Alejandro G. Riaño <agutierrez@softcontrol.es>
 */
@Component({
    components: {Loader, AuthorizationItemTree, PermissionDetail},
})
export default class PermissionsMaster extends Vue {
    public $refs: Vue['$refs'] & {
        tree: {
            navigateToNode: (path: string) => void,
        },
    }

    /**
     * Activa o desactiva la bandera que indica si el usuario se encuentra editando
     * un permiso
     */
    @Mutation('authorization/TOGGLE_EDITING_PERMISSION')
    public toggleEditingPermission: (editing: boolean) => void

    @Action('authorization/createNewPermission')
    public createNewPermission: (parent: string) => Permission

    /**
     * Comprobar autorización
     *
     * Solicita a la aplicación que compruebe si el usuario actualmente autenticado
     * posee los permisos argumentados
     */
    @Action('authorization/checkAuthorization')
    public checkAuthorization: (permission: string[]) => Promise<CheckAuthorizationResult>

    public loading = true

    public canCreatePermissions = false
    public canUpdatePermissions = false

    /**
     * Controla la visibilidad del dialogo que muestra la pantalla para editar un permiso.
     * Este dialogo solo es visible en modo movil.
     *
     * En modo escritorio, la pantalla para editar un permiso se encuentra en la
     * columna derecha
     */
    public permissionEditDialog = false

    /**
     * Crea un nuevo permiso e inserta un placeholder en el árbol
     */
    public async createPermission (path: string) {
        const permission = await this.createNewPermission(path)
        this.$refs.tree.navigateToNode(permission.path)
    }

    public select (permission: string) {
        this.$store.commit('authorization/SET_CURRENT_PERMISSION', permission)
        this.$store.commit('authorization/TOGGLE_EDITING_PERMISSION', true)
        this.permissionEditDialog = true
    }

    /**
     * Al crear el componente carga el árbol completo de permisos
     */
    public async created () {
        // Carga los permisos necesarios para la pantalla
        const auth = await this.checkAuthorization([
            '@/authorization/admin/permissions/create_permissions',
            '@/authorization/admin/permissions/update_permissions',
        ])

        this.canCreatePermissions = auth.isGranted('@/authorization/admin/permissions/create_permissions')
        this.canUpdatePermissions = auth.isGranted('@/authorization/admin/permissions/update_permissions')

        await this.$store.dispatch('authorization/loadFullPermissionTree')
        this.loading = false
    }

    public errorCaptured (error: Error) {
        notify(error.message, Colors.Error)
        this.$router.push({name: 'dashboard'})
    }
}
